"use strict";

exports.__esModule = true;
exports.navigateTo = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.withPrefix = withPrefix;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathPrefix = "/"; /*global __PREFIX_PATHS__, __PATH_PREFIX__ */

if (typeof __PREFIX_PATHS__ !== "undefined" && __PREFIX_PATHS__) {
  pathPrefix = __PATH_PREFIX__;
}

function withPrefix(path) {
  return normalizePath(pathPrefix + path);
}

function normalizePath(path) {
  return path.replace(/^\/\//g, "/");
}

var NavLinkPropTypes = {
  activeClassName: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  exact: _propTypes2.default.bool,
  strict: _propTypes2.default.bool,
  isActive: _propTypes2.default.func,
  location: _propTypes2.default.object

  // Set up IntersectionObserver
};var handleIntersection = function handleIntersection(el, cb) {
  var io = new window.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (el === entry.target) {
        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          io.unobserve(el);
          io.disconnect();
          cb();
        }
      }
    });
  });
  // Add element to the observer
  io.observe(el);
};

var GatsbyLink = function (_React$Component) {
  (0, _inherits3.default)(GatsbyLink, _React$Component);

  function GatsbyLink(props) {
    (0, _classCallCheck3.default)(this, GatsbyLink);

    // Default to no support for IntersectionObserver
    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

    var IOSupported = false;
    if (typeof window !== "undefined" && window.IntersectionObserver) {
      IOSupported = true;
    }

    _this.state = {
      to: withPrefix(props.to),
      IOSupported: IOSupported
    };
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }

  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.to !== nextProps.to) {
      this.setState({
        to: withPrefix(nextProps.to)
      });
      // Preserve non IO functionality if no support
      if (!this.state.IOSupported) {
        ___loader.enqueue(this.state.to);
      }
    }
  };

  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
    // Preserve non IO functionality if no support
    if (!this.state.IOSupported) {
      ___loader.enqueue(this.state.to);
    }
  };

  GatsbyLink.prototype.handleRef = function handleRef(ref) {
    var _this2 = this;

    this.props.innerRef && this.props.innerRef(ref);

    if (this.state.IOSupported && ref) {
      // If IO supported and element reference found, setup Observer functionality
      handleIntersection(ref, function () {
        ___loader.enqueue(_this2.state.to);
      });
    }
  };

  GatsbyLink.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        _onClick = _props.onClick,
        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);

    var El = void 0;
    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
      return _this3.props[propName];
    })) {
      El = _reactRouterDom.NavLink;
    } else {
      El = _reactRouterDom.Link;
    }

    return _react2.default.createElement(El, (0, _extends3.default)({
      onClick: function onClick(e) {
        // eslint-disable-line
        _onClick && _onClick(e);

        if (e.button === 0 && // ignore right clicks
        !_this3.props.target && // let browser handle "target=_blank"
        !e.defaultPrevented && // onClick prevented default
        !e.metaKey && // ignore clicks with modifier keys...
        !e.altKey && !e.ctrlKey && !e.shiftKey) {
          // Is this link pointing to a hash on the same page? If so,
          // just scroll there.
          var pathname = _this3.state.to;
          if (pathname.split("#").length > 1) {
            pathname = pathname.split("#").slice(0, -1).join("");
          }
          if (pathname === window.location.pathname) {
            var hashFragment = _this3.state.to.split("#").slice(1).join("#");
            var element = document.getElementById(hashFragment);
            if (element !== null) {
              element.scrollIntoView();
              return true;
            }
          }

          // In production, make sure the necessary scripts are
          // loaded before continuing.
          if (process.env.NODE_ENV === "production") {
            e.preventDefault();
            window.___navigateTo(_this3.state.to);
          }
        }

        return true;
      }
    }, rest, {
      to: this.state.to,
      innerRef: this.handleRef
    }));
  };

  return GatsbyLink;
}(_react2.default.Component);

GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
  innerRef: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  to: _propTypes2.default.string.isRequired
});

GatsbyLink.contextTypes = {
  router: _propTypes2.default.object
};

exports.default = GatsbyLink;
var navigateTo = exports.navigateTo = function navigateTo(pathname) {
  window.___navigateTo(withPrefix(pathname));
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/index.js
// module id = 10
// module chunks = 168707334958949